import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { Singleton } from '../Singletons/Singleton';
import { CURRENT_LANGUAGE } from '../constants/constants';
import { SingletonSharedData } from '../Singletons/SingletonSharedData';
import { triggerNotifications } from './helperMessages';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from '../constants/Notifications';

let instance = null;

export class helperLanguage {
  constructor(){
    if(!instance){
      instance = this;
      const APIFact = new APIFactory();
      this.apiCont = APIFact.buildClient();
      this.lagSingleton = new Singleton();
      this.sharedData = new SingletonSharedData();
    }
    return instance;
  }

  setLanguage(sdk, lang, languageObject){
    console.log('Language is: ' + lang);
    let currLang = '';
    if(lang === ''){
      if (currLang !== "") {
        this.lagSingleton.setLanguage(currLang);
      }
    }else{
      currLang = lang;

      this.lagSingleton.setLanguage(currLang);
    }
    this.getTags(sdk, currLang, languageObject);
  }


  getTags(sdk, currLang, languageObject){
    const _sdk = sdk;
    const objectResponse = this.apiCont.getObjectResponse();
    console.log('Current language: '+ currLang);
    this.apiCont.getLanguage(1, objectResponse);
    const _this = this;
    objectResponse.onSuccess = function(objResponse){
      _this.lagSingleton.setJsonLanguage(objResponse);
      _this.sharedData.setVersionAgent(objResponse.Response[3].version);
      _this.sharedData.setCountry(objResponse.Response[3].idPais);
      _this.sharedData.setIPfromAPI(objResponse.Response[4].Value);
      _this.sharedData.setIPAddress(objResponse.Response[4].Value);
      languageObject();
      const connectToServer ={
        connected:true,
        message: "Connection to server successfully",
      }
      _sdk.svrEvents.onSetDomain(connectToServer); 
      triggerNotifications(_sdk,MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);  
    };

    objectResponse.onError = function(messageError){
      const connectToServer ={
        connected:false,
        message: 'TypeError: Failed to fetch.',
      }
      _sdk.svrEvents.onSetDomain(connectToServer);
      triggerNotifications(_sdk, MESSAGE_CODE.LOGIN[10001], MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, 'TypeError: Failed to fetch');
    };

  }
}
